import { Button, Form, Input, Spin, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { checkEmployeesRvdType, checkIsUsersDublicate, dataForRvdUsersTable } from 'shared/helpers/utils';
import { EditOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/store';
import { rvdActions } from 'entities/rvd/model/Rvd';
import { useNavigate } from 'react-router-dom';
import ModalCancelSubmit from 'shared/components/modalCancelSubmit/ModalCancelSubmit';
import Breadcrumbs from 'shared/components/breadcrumbs/Breadcrumbs';
import CommonTable from 'features/tables/commonTable';
import { ExcelRvdCompensationTypeToFront, RvdStatusToBack } from 'shared/enums/rvd';
import { useLazyGetEmployeesQuery } from 'app/services/edpApiV1/employees';
import { TCommonColumns } from 'shared/types/overtime.types';
import { RvdUserPreparedInfo, TUserRvdInfo } from 'shared/types/rvd.types';
import { useCreateRvdMutation, useCreateRvdUserMutation } from 'app/services/edpApiV1/rvd';
import { checkRvdCompensationTypeToBack } from 'shared/helpers/type-check';
import EmployeeInput from 'features/absence/madalAddOneAbsence/employeeInput';
import { TDivisionEmployees } from 'shared/types/types';
import { useLazyGetDivisionEmployeesQuery } from 'app/services/edpApiV1/viewer';
import { validateBreakTime, validateExcelDataRvd } from 'shared/helpers/validate';
import { MUST_HAVE_BRAKE, NOT_PROVIDED_DATE_RVD, NOT_PROVIDED_TIME_RVD } from 'shared/constants/rvd';
import moment from 'moment';
import { PICKER_TIME_MASK } from 'shared/constants';
import { calcTime, excelToDate } from 'features/overtime/uploadExcell/UploadExcell';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { viewerModel } from 'entities/viewer';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import { uiModel } from 'entities/ui';
import UploadExcell from '../uploadExcell/UploadExcell';
import { RvdTabs } from '..';
import style from './index.module.scss';
import RvdSidebar from './sidebar/RvdSidebar';

const breadCrumbs = [
  { name: 'Работа в выходной день', link: '/rvd' },
  { name: 'Создать заявку', link: `/rvd/new` },
];

const FORM_ITEM_NAME = 'signatoryRvdCreate';
const HOURS_TO_REQUIRE_BREAK = 4;

const CreateRvdRequest = () => {
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const dispatch = useAppDispatch();
  const currentRvd = useAppSelector(state => state.entities.rvd.rvd);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<TUserRvdInfo | undefined>();
  const [isSidebarCreateOpen, setIsSidebarCreateOpen] = useState<boolean>(false);
  const [isSidebarUpdateOpen, setIsSidebarUpdateOpen] = useState<boolean>(false);
  const [excellFetching, setExcellFetching] = useState<boolean>(false);
  const [signatory, setSignatory] = useState<TDivisionEmployees | null>(null);
  const [getSignatories, { data: signatories }] = useLazyGetDivisionEmployeesQuery();
  const [rvdCreating, setRvdCreating] = useState<boolean>(false);

  const [createRvdRequest, { isLoading: isRvdCreateLoading }] = useCreateRvdMutation();
  const [createRvdUserRequest] = useCreateRvdUserMutation();

  const navigate = useNavigate();
  const [getEmployees] = useLazyGetEmployeesQuery();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);
  const currentOrganizationid = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);

  useEffect(() => {
    if (signatory) {
      form.setFieldValue(FORM_ITEM_NAME, signatory?.id);
      getSignatories({
        page: 1,
        size: 10,
        search: `${signatory.lastName} ${signatory.name} ${signatory.middleName}`,
        allAvailableOrganizations,
      });
    }
  }, [signatory]);

  const columns: TCommonColumns = [
    {
      title: 'Дата работ',
      dataIndex: 'toDate',
      key: 'toDate',
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Табельный номер',
      dataIndex: 'personnelNumber',
      key: 'personnelNumber',
    },
    {
      title: 'Подразделение',
      dataIndex: 'division',
      key: 'division',
    },
    {
      title: 'Время работы',
      dataIndex: 'duration',
      key: 'duration',
    },
    {
      title: 'Способ компенсации',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  const openDrawerCreate = () => {
    setIsSidebarCreateOpen(true);
  };

  const onCloseCreate = () => {
    setIsSidebarCreateOpen(false);
  };

  const onCloseUpdate = () => {
    setIsSidebarUpdateOpen(false);
  };

  const onFinishExcell = (rvdUsers: unknown) => {
    const rvd = { ...currentRvd, toDate: (rvdUsers as TUserRvdInfo[])[0].toDate };
    rvd.employees = rvdUsers as TUserRvdInfo[];
    dispatch(rvdActions.setCurrent(rvd));
  };

  const onFinishCreate = (rvdUser: TUserRvdInfo) => {
    const rvd = { ...currentRvd };
    rvdUser.id = Math.random();
    rvd.employees = [...currentRvd.employees, rvdUser];

    dispatch(rvdActions.setCurrent(rvd));
    setIsSidebarCreateOpen(false);
  };

  const onFinishUpdate = (rvdUser: TUserRvdInfo) => {
    const newRvdUsers = { ...currentRvd }.employees.map(user => {
      if (user.id === rvdUser.id) {
        return rvdUser;
      }
      return user;
    });
    const newRvd = { ...currentRvd };
    newRvd.employees = newRvdUsers;
    setCurrentUser(rvdUser);
    setIsSidebarUpdateOpen(false);
    dispatch(rvdActions.setCurrent(newRvd));
  };

  const getUserByPersonnelNumber = async (personnelNumber: string | undefined): Promise<TDivisionEmployees> => {
    const employee = await getEmployees({
      isActive: true,
      page: 1,
      size: 1,
      personnelNumber: personnelNumber,
      allAvailableOrganizations,
      organizationId: currentOrganizationid,
    }).unwrap();
    return {
      id: employee.data[0].id,
      division: employee.data[0].division!.name,
      personnelNumber: employee.data[0].personnelNumber,
      lastName: employee.data[0].lastName,
      middleName: employee.data[0].middleName,
      name: employee.data[0].name,
      position: '',
    };
  };

  const rowClicked = (id: number) => {
    const user = currentRvd.employees.find(item => item.id === id);
    if (user) {
      setCurrentUser(user);
    }
    setIsSidebarUpdateOpen(prev => !prev);
  };

  const createRvd = async () => {
    if (checkIsUsersDublicate(currentRvd.employees)) {
      notification.error({
        message: 'Пользователи в заявке дублируются',
      });
      return;
    }
    try {
      setRvdCreating(true);

      const rvdUsers: RvdUserPreparedInfo[] = currentRvd.employees.map(user => ({
        employeeId: user.userInfo.id,
        endBreakTime: user.endBreakTime,
        endTime: user.endTime,
        isInVacation: user.isInVacation,
        startBreakTime: user.startBreakTime,
        startTime: user.startTime,
        toDate: user.toDate,
        type: checkRvdCompensationTypeToBack(user.type),
      }));

      checkEmployeesRvdType(rvdUsers);

      const rvdIdObject = await createRvdRequest({
        status: RvdStatusToBack[currentRvd.status],
        docSignatory: signatory!.personnelNumber,
        userComment: form.getFieldValue('comment'),
      }).unwrap();

      await createRvdUserRequest({ employee: rvdUsers, wowId: rvdIdObject.id }).unwrap();
      setRvdCreating(false);
      notification.success({
        message: 'Заявка создана успешно',
      });
      dispatch(uiModel.Tabs.actions.setActive(RvdTabs.new));
      navigate('/rvd');
    } catch (e: any) {
      setRvdCreating(false);
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  const cancelModalOpen = () => {
    setModalOpen(true);
  };

  const cancelModalClose = () => {
    setModalOpen(false);
    dispatch(rvdActions.clearCurrent());

    dispatch(uiModel.Tabs.actions.setActive(RvdTabs.new));
    navigate('/rvd');
  };

  const cancelModalSubmit = () => {
    setModalOpen(false);
  };

  const parseExcell = async (data: (string | number)[][]): Promise<TUserRvdInfo[]> => {
    let startPayloadLine = 0;
    let startPayloadFlag = false;
    const sygnatoryPersonnelNumber: string = data[2][3] as string;

    try {
      const excelDocSignatory = await getUserByPersonnelNumber(sygnatoryPersonnelNumber);
      setSignatory(excelDocSignatory);
    } catch (e) {
      notification.error({
        message: `Не найден подписант с ТН ${sygnatoryPersonnelNumber}`,
        duration: 0,
      });
    }

    const preparedUsers: TUserRvdInfo[] = [];
    setExcellFetching(true);
    for (let line = 0; line < data.length; line++) {
      if (startPayloadFlag && line >= startPayloadLine) {
        if (typeof data[line][0] === 'number') {
          let currentUserExcel: TDivisionEmployees | undefined;
          const currentUserPersonnelNumber: string = data[line][1] as string;
          try {
            currentUserExcel = await getUserByPersonnelNumber(currentUserPersonnelNumber);
          } catch (e) {
            notification.error({
              message: `Не найден пользователь с ТН ${currentUserPersonnelNumber}`,
              duration: 0,
            });
          }
          if (currentUserExcel) {
            try {
              validateExcelDataRvd(data, line);
              const startTime = calcTime(data[line][8]);
              const endTime = calcTime(data[line][9]);
              const startBreakTime = data[line][10] ? calcTime(data[line][10]) : undefined;
              const endBreakTime = data[line][11] ? calcTime(data[line][11]) : undefined;

              const startHour = moment(startTime, PICKER_TIME_MASK).hour();
              const endHour = moment(endTime, PICKER_TIME_MASK).hour();
              const timeDiff = Math.abs(startHour - endHour);

              if (timeDiff >= HOURS_TO_REQUIRE_BREAK) {
                if (!startBreakTime || !endBreakTime) {
                  throw new Error(MUST_HAVE_BRAKE);
                }
              }

              const isBreakValid = validateBreakTime(startBreakTime, endBreakTime);
              if (!isBreakValid) {
                throw new Error(MUST_HAVE_BRAKE);
              }
              const toDate = +data[line][7];
              const isInVacation = data[line][5];
              const compensationType = data[line][14];
              const preparedUser: TUserRvdInfo = {
                id: Math.random() * 1000000,
                toDate: excelToDate(toDate),
                isInVacation: isInVacation === 'да' ? true : false,
                startTime,
                endTime,
                startBreakTime: isBreakValid ? startBreakTime : undefined,
                endBreakTime: isBreakValid ? endBreakTime : undefined,
                type: ExcelRvdCompensationTypeToFront[compensationType],
                userInfo: currentUserExcel,
              };
              preparedUsers.push(preparedUser);
            } catch (e) {
              const errorMessage = (e as Error).message;
              if (
                errorMessage === NOT_PROVIDED_DATE_RVD ||
                errorMessage === NOT_PROVIDED_TIME_RVD ||
                errorMessage === MUST_HAVE_BRAKE
              ) {
                notification.error({
                  message: `${currentUserPersonnelNumber}: ${errorMessage}`,
                  duration: 0,
                });
              } else {
                notification.error({
                  message: 'Не удалось прочитать файл Excel, проверьте правильность заполнения',
                  duration: 0,
                });
              }
            }
          }
        } else {
          break;
        }
      }
      if (data[line][0] === '№' && data[line][1] === 'Табельный номер') {
        startPayloadLine = line + 2;
        startPayloadFlag = true;
      }
    }
    setExcellFetching(false);
    return preparedUsers;
  };

  const deleteUser = (id: number | string) => {
    const rvd = { ...currentRvd };
    const users = rvd.employees.filter(user => user.id !== id);
    rvd.employees = users;
    dispatch(rvdActions.setCurrent(rvd));
    setIsSidebarUpdateOpen(false);
  };

  return (
    <>
      <div className={style['top-side']}>
        <h3 className={style.title}>
          <Breadcrumbs breadCrumbs={breadCrumbs} />
        </h3>
        <div className={style.buttons}>
          <UploadExcell onFinishExcell={onFinishExcell} parseExcell={parseExcell} />
          <Button onClick={openDrawerCreate}>
            <EditOutlined />
            Добавить вручную
          </Button>
          <Button
            type="primary"
            disabled={currentRvd.employees.length < 1 || !signatory || allAvailableOrganizations}
            loading={isRvdCreateLoading || excellFetching || rvdCreating}
            onClick={createRvd}
          >
            Создать
          </Button>

          <Button onClick={cancelModalOpen}>Отмена</Button>
          <ModalCancelSubmit open={modalOpen} onStay={cancelModalSubmit} onQuit={cancelModalClose} />
        </div>
      </div>
      <RvdSidebar onClose={onCloseCreate} isOpen={isSidebarCreateOpen} onOk={onFinishCreate} currentRvd={currentRvd} />
      <RvdSidebar
        onClose={onCloseUpdate}
        isOpen={isSidebarUpdateOpen}
        onOk={onFinishUpdate}
        currentRvd={currentRvd}
        currentUser={currentUser}
        remove={deleteUser}
      />
      <Spin spinning={excellFetching || rvdCreating}>
        <CommonTable
          dataSource={dataForRvdUsersTable(currentRvd.employees)}
          columns={columns}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentPage={setCurrentPage}
          setCurrentSize={setCurrentSize}
          total={currentRvd.employees.length}
          onclickToRow={rowClicked}
          selfPaginated={true}
        />
      </Spin>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={() => {}}
        autoComplete="off"
      >
        <EmployeeInput
          data={signatories}
          getEmployees={getSignatories}
          setEmployee={setSignatory}
          divisionName={signatory?.division}
          label="Выберите руководителя"
          rules={[{ required: true, message: 'Выберите руководителя!' }]}
          className="form-item-rvd"
          onChangeEmployee={() => {}}
          defaultUser={currentUser?.userInfo}
          formItemName={FORM_ITEM_NAME}
        />
        <Form.Item name={'comment'} label={'Введите комментарий'}>
          <Input placeholder="Введите комментарий" />
        </Form.Item>
      </Form>
    </>
  );
};

export default CreateRvdRequest;
